// utils/voucherErrorHandler.js
export function parseVoucherError(error) {
  const status = error?.status || error?.response?.status;
  const detail =
    error?.message ||
    error?.response?.data?.detail ||
    error?.response?.data?.error ||
    "Voucher validation failed.";

  if (typeof detail === "string") {
    if (
      detail.toLowerCase().includes("not found") ||
      detail.toLowerCase().includes("invalid") ||
      detail.toLowerCase().includes("expired")
    ) {
      return "Voucher not found or expired.";
    }
    if (detail.toLowerCase().includes("already used")) {
      return "Voucher has already been used.";
    }
  }

  if (!status) {
    return "Connection error. Please check your internet connection and try again.";
  }

  switch (status) {
    case 400:
      return "Invalid voucher format. Please check your input.";
    case 404:
      return "Voucher not found. Please check the code and try again.";
    case 401:
      return "Your session has expired. Please sign in again.";
    case 403:
      return "You are not authorized to use this voucher.";
    case 422:
      return "Voucher validation failed. Code may be invalid.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Voucher service temporarily unavailable. Please try again.";
    default:
      return "Voucher validation failed. Please check the code or contact support.";
  }
}
